<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" width="11.975" height="12" viewBox="0 0 11.975 12">
        <path id="first_page_FILL0_wght400_GRAD0_opsz24" d="M16.3,17.3l-4.6-4.6a.872.872,0,0,1-.212-.325,1.148,1.148,0,0,1,0-.75A.872.872,0,0,1,11.7,11.3l4.6-4.6a.99.99,0,0,1,1.4,1.4L13.8,12l3.9,3.9a.99.99,0,0,1-1.4,1.4ZM7,18a.982.982,0,0,1-1-1V7A1,1,0,1,1,8,7V17a.982.982,0,0,1-1,1Z" transform="translate(-6 -6)" fill="#034ad9"/>
    </svg>
</template>
